import { useState } from 'react';
import { Button } from '@/components/Button';
import { MdCheckCircle } from 'react-icons/md';
import usePostOrganizationTutorials from '@/features/agent/api/usePostOrganizationTutorials';
import usePostOrganizationTutorialComplete from '@/features/agent/api/usePostOrganizationTutorialComplete';
import useFetchOrganizationTutorials from '@/features/agent/api/useFetchOrganizationTutorials';
import { showErrorToast } from '@/features/agent/job_change_processes/lib/toast';
import WalkthroughLayout from './WalkthroughLayout';

type Props = {
  onComplete: () => void;
};

export default function WalkthroughCompletion({ onComplete }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { mutateAsync: postOrganizationTutorials } = usePostOrganizationTutorials();
  const { mutateAsync: postOrganizationTutorialComplete } = usePostOrganizationTutorialComplete();
  const { refetch: refetchTutorials } = useFetchOrganizationTutorials();

  const handleStart = async () => {
    setIsSubmitting(true);
    try {
      // デフォルトチュートリアルを作成
      await postOrganizationTutorials(['data_management']);

      // 作成されたチュートリアルを取得
      const refetchResult = await refetchTutorials();

      // 未完了のチュートリアルを特定して完了にする
      const unfinishedTutorial = refetchResult.data?.records.find((t) => !t.is_finished);

      if (!unfinishedTutorial) {
        showErrorToast('チュートリアルの作成に失敗しました');
        setIsSubmitting(false);
        return;
      }

      await postOrganizationTutorialComplete(unfinishedTutorial.id);
      await refetchTutorials();

      onComplete();
    } catch {
      showErrorToast('処理に失敗しました');
      setIsSubmitting(false);
    }
  };

  return (
    <WalkthroughLayout>
      <div className="flex h-full flex-col items-center justify-center gap-8">
        <MdCheckCircle size={64} className="text-primary" />
        <div className="flex flex-col items-center gap-3">
          <p className="text-xl font-bold text-primary">取り込みが開始されました</p>
          <p className="text-sm text-[#6D6D6D]">求人の取り込みはバックグラウンドで実行されます。</p>
        </div>
        <Button
          type="button"
          onClick={handleStart}
          disabled={isSubmitting}
          className="mt-4 h-[52px] w-[320px]"
        >
          無料で始める
        </Button>
      </div>
    </WalkthroughLayout>
  );
}
